module.exports = __webpack_public_path__ + "img/citizen.153fcf35.jpg";